// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/SearchForm/SearchForm.css */

.list-container {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: auto;
  background:
    linear-gradient(180deg, #ffffff 0%, #f5f8fb 100%);
  border: 1px solid rgba(36, 52, 71, 0.1);
  border-radius: 8px;
  box-shadow: 0 16px 34px rgba(36, 52, 71, 0.11);
  margin: auto;
  text-align: left;
  transition: all 0.3s ease-in-out;
}

.list_form_headi {
  margin: 0;
  color: #243447;
  font-size: 1.28rem;
  line-height: 1.2;
  font-weight: 900;
  text-transform: uppercase;
  border-bottom: 2px solid #EF6F53;
  letter-spacing: 0;
}

.list_form_ul {
  list-style-type: none;
  padding: 0;
  margin: 1rem;
  font-size: 1rem;
  box-sizing: border-box;
}


/* Pagination Styling */
.pagination-container {
background-color: #364C63;
padding: 0.5rem; 
border-top: 2px solid #EF6F53; 
}

.pagination {
display: flex;
justify-content: center;
align-items: center;
background-color: #364C63;
border-radius: 10px;
overflow-x: auto;
margin: auto;
}

.pagination button {
background-color: #EF6F53;
color: white;
border: none;
margin: 0 5px;
padding: 0.5rem;
padding-top: 0.25rem;
padding-bottom: 0.25rem;
font-size: 0.6rem; 
border-radius: 5px;
font-weight: 600;
cursor: pointer;
}

.pagination button:hover {
background-color: #FF8369; 
}

.pagination button.active {
background-color: #dd3e1e;
font-weight: bold;
}

.pagination button:focus {
outline: none;
}

.pagination button:disabled {
background-color: #ccc;
cursor: not-allowed;
}

.ellipsis {
margin: 0 5px;
color: #EF6F53;
font-weight: bold;
}
.page-number {
margin: 0 5px;
padding: 5px 10px;
cursor: pointer;
}

.page-number.active {
background-color: #007bff;
color: #fff;
border-radius: 5px;
}


.customers-table td:first-child,
.customers-table th:first-child {
  padding-left: clamp(0.24rem, 0.7vw, 0.52rem);
}

.table-container {
  width: 100%;
  overflow-x: hidden;
  padding: 0 clamp(0.28rem, 1.2vw, 0.75rem) clamp(0.35rem, 1.2vw, 0.75rem);
  min-width: 0;
}

.customers-table {
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  margin: 0;
  background-color: #ffffff;
  border: 1px solid rgba(36, 52, 71, 0.14);
  border-radius: 8px;
  box-shadow: 0 14px 28px rgba(36, 52, 71, 0.1);
  font-size: clamp(0.58rem, 0.72vw, 0.76rem);
  line-height: 1.22;
  overflow: hidden;
}

.customers-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background:
    linear-gradient(135deg, #243447 0%, #24516f 58%, #1976d2 100%);
  color: #ffffff;
  padding: clamp(0.25rem, 0.62vw, 0.48rem) clamp(0.22rem, 0.62vw, 0.55rem);
  text-align: left;
  border-right: 1px solid rgba(255, 255, 255, 0.16);
  border-bottom: 1px solid rgba(36, 52, 71, 0.22);
  font-size: clamp(0.52rem, 0.64vw, 0.68rem);
  font-weight: 900;
  line-height: 1.15;
  text-transform: uppercase;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: normal;
}

.customers-table th:last-child {
  border-right: 0;
}

.customers-table td {
  padding: clamp(0.24rem, 0.58vw, 0.42rem) clamp(0.22rem, 0.62vw, 0.55rem);
  border-right: 1px solid rgba(36, 52, 71, 0.09);
  border-bottom: 1px solid rgba(36, 52, 71, 0.09);
  color: #334155;
  font-weight: 650;
  vertical-align: middle;
  overflow-wrap: anywhere;
  word-break: break-word;
  background: rgba(255, 255, 255, 0.96);
}

.customers-table td:last-child {
  border-right: 0;
}

.customers-table tbody tr:nth-child(even) td {
  background: #f8fbff;
}

.customers-table tbody tr:last-child td {
  border-bottom: 0;
}

.customers-table th:nth-child(2),
.customers-table td:nth-child(2) {
  min-width: 0;
}

.customers-table th:nth-child(1),
.customers-table td:nth-child(1) {
  width: 12%;
}

.customers-table th:nth-child(2),
.customers-table td:nth-child(2) {
  width: 11%;
}

.customers-table th:nth-child(3),
.customers-table td:nth-child(3) {
  width: 14%;
}

.customers-table th:nth-child(4),
.customers-table td:nth-child(4) {
  width: 9%;
}

.customers-table th:nth-child(5),
.customers-table td:nth-child(5) {
  width: 12%;
}

.customers-table th:nth-child(6),
.customers-table td:nth-child(6) {
  width: 11%;
}

.customers-table th:nth-child(7),
.customers-table td:nth-child(7) {
  width: 10%;
}

.customers-table th:nth-child(8),
.customers-table td:nth-child(8) {
  width: 12%;
}

.customers-table th:nth-child(9),
.customers-table td:nth-child(9) {
  width: 9%;
}

.customers-table th:nth-child(2) {
  color: #ffffff;
  font-weight: 700;
}

.customers-table td:nth-child(2) {
  color: #24516f;
  font-weight: 900;
}

.customers-table td:nth-child(2) a {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  padding: 0.18rem 0.42rem;
  border: 1px solid rgba(25, 118, 210, 0.18);
  border-radius: 999px;
  background: rgba(25, 118, 210, 0.08);
  color: #1769aa;
  font-weight: 900;
  text-decoration: none;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.customers-table td:nth-child(2) a:hover {
  color: #ef6f53;
  border-color: rgba(239, 111, 83, 0.3);
  background: rgba(239, 111, 83, 0.08);
}

.customers-table td:nth-child(4),
.customers-table td:nth-child(6),
.customers-table td:nth-child(7) {
  color: #243447;
  font-weight: 800;
}

.customers-table tbody tr {
  transition: transform 150ms ease, box-shadow 150ms ease;
}

.customers-table tbody tr:hover td {
  background: #fff7f3;
  border-bottom-color: rgba(239, 111, 83, 0.22);
  cursor: pointer;
}

.selected-row {
  background-color: transparent;
}

.customers-table tbody tr.selected-row td {
  background: #eaf4ff;
  box-shadow: inset 3px 0 0 #1976d2;
}

.header-containerrr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.85rem 0.9rem 0.7rem;
  position: relative;
  gap: 0.75rem;
}

.header-center {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  position: relative;
}

.header-right {
  display: flex;
  align-items: center;
}

.home-icon {
  width: 30px;
  height: 30px;
  padding: 6px;
  border: 1px solid rgba(36, 52, 71, 0.12);
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(36, 52, 71, 0.09);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.home-icon:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(36, 52, 71, 0.14);
}

.add-record-btnnn {
  background-color: #EF6F53;
  color: white;
  border: none;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  margin-left: auto;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.add-record-btnnn:hover {
  background-color: #f8360b;
  transform: translateY(-1px);
}

.add-record-btnnn:active {
  transform: translateY(0);
}

@media (max-width: 900px) {
  .list-container {
    border-radius: 6px;
  }

  .header-containerrr {
    padding: 0.62rem 0.5rem 0.48rem;
    gap: 0.45rem;
  }

  .list_form_headi {
    font-size: clamp(0.78rem, 2.7vw, 1.05rem);
  }

  .customers-table {
    font-size: clamp(0.48rem, 1.45vw, 0.62rem);
    line-height: 1.14;
    border-radius: 6px;
  }

  .customers-table th,
  .customers-table td {
    padding: 0.2rem 0.18rem;
  }

  .customers-table th {
    font-size: clamp(0.45rem, 1.28vw, 0.55rem);
  }

  .customers-table td:nth-child(2) a {
    padding: 0.12rem 0.2rem;
    border-radius: 6px;
  }
}

@media (max-width: 560px) {
  .table-container {
    padding-left: 0.2rem;
    padding-right: 0.2rem;
  }

  .customers-table {
    font-size: clamp(0.42rem, 1.75vw, 0.52rem);
  }

  .customers-table th,
  .customers-table td {
    padding: 0.16rem 0.12rem;
    border-right-color: rgba(36, 52, 71, 0.08);
  }

  .customers-table th {
    font-size: clamp(0.38rem, 1.6vw, 0.48rem);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/SearchForm/SearchForm.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ;qDACmD;EACnD,uCAAuC;EACvC,kBAAkB;EAClB,8CAA8C;EAC9C,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;;AAGA,uBAAuB;AACvB;AACA,yBAAyB;AACzB,eAAe;AACf,6BAA6B;AAC7B;;AAEA;AACA,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,yBAAyB;AACzB,mBAAmB;AACnB,gBAAgB;AAChB,YAAY;AACZ;;AAEA;AACA,yBAAyB;AACzB,YAAY;AACZ,YAAY;AACZ,aAAa;AACb,eAAe;AACf,oBAAoB;AACpB,uBAAuB;AACvB,iBAAiB;AACjB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf;;AAEA;AACA,yBAAyB;AACzB;;AAEA;AACA,yBAAyB;AACzB,iBAAiB;AACjB;;AAEA;AACA,aAAa;AACb;;AAEA;AACA,sBAAsB;AACtB,mBAAmB;AACnB;;AAEA;AACA,aAAa;AACb,cAAc;AACd,iBAAiB;AACjB;AACA;AACA,aAAa;AACb,iBAAiB;AACjB,eAAe;AACf;;AAEA;AACA,yBAAyB;AACzB,WAAW;AACX,kBAAkB;AAClB;;;AAGA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wEAAwE;EACxE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;EACT,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,6CAA6C;EAC7C,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV;kEACgE;EAChE,cAAc;EACd,wEAAwE;EACxE,gBAAgB;EAChB,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wEAAwE;EACxE,8CAA8C;EAC9C,+CAA+C;EAC/C,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,0CAA0C;EAC1C,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,+BAA+B;IAC/B,YAAY;EACd;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,0CAA0C;IAC1C,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;;IAEE,wBAAwB;IACxB,0CAA0C;EAC5C;;EAEA;IACE,yCAAyC;EAC3C;AACF","sourcesContent":["/* src/components/routes/Forms/SearchForm/SearchForm.css */\n\n.list-container {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  height: auto;\n  background:\n    linear-gradient(180deg, #ffffff 0%, #f5f8fb 100%);\n  border: 1px solid rgba(36, 52, 71, 0.1);\n  border-radius: 8px;\n  box-shadow: 0 16px 34px rgba(36, 52, 71, 0.11);\n  margin: auto;\n  text-align: left;\n  transition: all 0.3s ease-in-out;\n}\n\n.list_form_headi {\n  margin: 0;\n  color: #243447;\n  font-size: 1.28rem;\n  line-height: 1.2;\n  font-weight: 900;\n  text-transform: uppercase;\n  border-bottom: 2px solid #EF6F53;\n  letter-spacing: 0;\n}\n\n.list_form_ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 1rem;\n  font-size: 1rem;\n  box-sizing: border-box;\n}\n\n\n/* Pagination Styling */\n.pagination-container {\nbackground-color: #364C63;\npadding: 0.5rem; \nborder-top: 2px solid #EF6F53; \n}\n\n.pagination {\ndisplay: flex;\njustify-content: center;\nalign-items: center;\nbackground-color: #364C63;\nborder-radius: 10px;\noverflow-x: auto;\nmargin: auto;\n}\n\n.pagination button {\nbackground-color: #EF6F53;\ncolor: white;\nborder: none;\nmargin: 0 5px;\npadding: 0.5rem;\npadding-top: 0.25rem;\npadding-bottom: 0.25rem;\nfont-size: 0.6rem; \nborder-radius: 5px;\nfont-weight: 600;\ncursor: pointer;\n}\n\n.pagination button:hover {\nbackground-color: #FF8369; \n}\n\n.pagination button.active {\nbackground-color: #dd3e1e;\nfont-weight: bold;\n}\n\n.pagination button:focus {\noutline: none;\n}\n\n.pagination button:disabled {\nbackground-color: #ccc;\ncursor: not-allowed;\n}\n\n.ellipsis {\nmargin: 0 5px;\ncolor: #EF6F53;\nfont-weight: bold;\n}\n.page-number {\nmargin: 0 5px;\npadding: 5px 10px;\ncursor: pointer;\n}\n\n.page-number.active {\nbackground-color: #007bff;\ncolor: #fff;\nborder-radius: 5px;\n}\n\n\n.customers-table td:first-child,\n.customers-table th:first-child {\n  padding-left: clamp(0.24rem, 0.7vw, 0.52rem);\n}\n\n.table-container {\n  width: 100%;\n  overflow-x: hidden;\n  padding: 0 clamp(0.28rem, 1.2vw, 0.75rem) clamp(0.35rem, 1.2vw, 0.75rem);\n  min-width: 0;\n}\n\n.customers-table {\n  width: 100%;\n  max-width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n  border-spacing: 0;\n  margin: 0;\n  background-color: #ffffff;\n  border: 1px solid rgba(36, 52, 71, 0.14);\n  border-radius: 8px;\n  box-shadow: 0 14px 28px rgba(36, 52, 71, 0.1);\n  font-size: clamp(0.58rem, 0.72vw, 0.76rem);\n  line-height: 1.22;\n  overflow: hidden;\n}\n\n.customers-table th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background:\n    linear-gradient(135deg, #243447 0%, #24516f 58%, #1976d2 100%);\n  color: #ffffff;\n  padding: clamp(0.25rem, 0.62vw, 0.48rem) clamp(0.22rem, 0.62vw, 0.55rem);\n  text-align: left;\n  border-right: 1px solid rgba(255, 255, 255, 0.16);\n  border-bottom: 1px solid rgba(36, 52, 71, 0.22);\n  font-size: clamp(0.52rem, 0.64vw, 0.68rem);\n  font-weight: 900;\n  line-height: 1.15;\n  text-transform: uppercase;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: normal;\n}\n\n.customers-table th:last-child {\n  border-right: 0;\n}\n\n.customers-table td {\n  padding: clamp(0.24rem, 0.58vw, 0.42rem) clamp(0.22rem, 0.62vw, 0.55rem);\n  border-right: 1px solid rgba(36, 52, 71, 0.09);\n  border-bottom: 1px solid rgba(36, 52, 71, 0.09);\n  color: #334155;\n  font-weight: 650;\n  vertical-align: middle;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  background: rgba(255, 255, 255, 0.96);\n}\n\n.customers-table td:last-child {\n  border-right: 0;\n}\n\n.customers-table tbody tr:nth-child(even) td {\n  background: #f8fbff;\n}\n\n.customers-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.customers-table th:nth-child(2),\n.customers-table td:nth-child(2) {\n  min-width: 0;\n}\n\n.customers-table th:nth-child(1),\n.customers-table td:nth-child(1) {\n  width: 12%;\n}\n\n.customers-table th:nth-child(2),\n.customers-table td:nth-child(2) {\n  width: 11%;\n}\n\n.customers-table th:nth-child(3),\n.customers-table td:nth-child(3) {\n  width: 14%;\n}\n\n.customers-table th:nth-child(4),\n.customers-table td:nth-child(4) {\n  width: 9%;\n}\n\n.customers-table th:nth-child(5),\n.customers-table td:nth-child(5) {\n  width: 12%;\n}\n\n.customers-table th:nth-child(6),\n.customers-table td:nth-child(6) {\n  width: 11%;\n}\n\n.customers-table th:nth-child(7),\n.customers-table td:nth-child(7) {\n  width: 10%;\n}\n\n.customers-table th:nth-child(8),\n.customers-table td:nth-child(8) {\n  width: 12%;\n}\n\n.customers-table th:nth-child(9),\n.customers-table td:nth-child(9) {\n  width: 9%;\n}\n\n.customers-table th:nth-child(2) {\n  color: #ffffff;\n  font-weight: 700;\n}\n\n.customers-table td:nth-child(2) {\n  color: #24516f;\n  font-weight: 900;\n}\n\n.customers-table td:nth-child(2) a {\n  display: inline-flex;\n  align-items: center;\n  width: fit-content;\n  max-width: 100%;\n  padding: 0.18rem 0.42rem;\n  border: 1px solid rgba(25, 118, 210, 0.18);\n  border-radius: 999px;\n  background: rgba(25, 118, 210, 0.08);\n  color: #1769aa;\n  font-weight: 900;\n  text-decoration: none;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.customers-table td:nth-child(2) a:hover {\n  color: #ef6f53;\n  border-color: rgba(239, 111, 83, 0.3);\n  background: rgba(239, 111, 83, 0.08);\n}\n\n.customers-table td:nth-child(4),\n.customers-table td:nth-child(6),\n.customers-table td:nth-child(7) {\n  color: #243447;\n  font-weight: 800;\n}\n\n.customers-table tbody tr {\n  transition: transform 150ms ease, box-shadow 150ms ease;\n}\n\n.customers-table tbody tr:hover td {\n  background: #fff7f3;\n  border-bottom-color: rgba(239, 111, 83, 0.22);\n  cursor: pointer;\n}\n\n.selected-row {\n  background-color: transparent;\n}\n\n.customers-table tbody tr.selected-row td {\n  background: #eaf4ff;\n  box-shadow: inset 3px 0 0 #1976d2;\n}\n\n.header-containerrr {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.85rem 0.9rem 0.7rem;\n  position: relative;\n  gap: 0.75rem;\n}\n\n.header-center {\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n}\n\n.home-icon {\n  width: 30px;\n  height: 30px;\n  padding: 6px;\n  border: 1px solid rgba(36, 52, 71, 0.12);\n  border-radius: 8px;\n  background: #ffffff;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(36, 52, 71, 0.09);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.home-icon:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 24px rgba(36, 52, 71, 0.14);\n}\n\n.add-record-btnnn {\n  background-color: #EF6F53;\n  color: white;\n  border: none;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 500;\n  margin-left: auto;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.add-record-btnnn:hover {\n  background-color: #f8360b;\n  transform: translateY(-1px);\n}\n\n.add-record-btnnn:active {\n  transform: translateY(0);\n}\n\n@media (max-width: 900px) {\n  .list-container {\n    border-radius: 6px;\n  }\n\n  .header-containerrr {\n    padding: 0.62rem 0.5rem 0.48rem;\n    gap: 0.45rem;\n  }\n\n  .list_form_headi {\n    font-size: clamp(0.78rem, 2.7vw, 1.05rem);\n  }\n\n  .customers-table {\n    font-size: clamp(0.48rem, 1.45vw, 0.62rem);\n    line-height: 1.14;\n    border-radius: 6px;\n  }\n\n  .customers-table th,\n  .customers-table td {\n    padding: 0.2rem 0.18rem;\n  }\n\n  .customers-table th {\n    font-size: clamp(0.45rem, 1.28vw, 0.55rem);\n  }\n\n  .customers-table td:nth-child(2) a {\n    padding: 0.12rem 0.2rem;\n    border-radius: 6px;\n  }\n}\n\n@media (max-width: 560px) {\n  .table-container {\n    padding-left: 0.2rem;\n    padding-right: 0.2rem;\n  }\n\n  .customers-table {\n    font-size: clamp(0.42rem, 1.75vw, 0.52rem);\n  }\n\n  .customers-table th,\n  .customers-table td {\n    padding: 0.16rem 0.12rem;\n    border-right-color: rgba(36, 52, 71, 0.08);\n  }\n\n  .customers-table th {\n    font-size: clamp(0.38rem, 1.6vw, 0.48rem);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
